module.exports = __webpack_public_path__ + "static/media/19ESCAP4.bd1f4bb7.jpg";